
import { defineComponent, onMounted, computed } from "vue";
import { useContent } from "../../composables/useContent";
import CollectionCard from "@/components/Collection/CollectionCard.vue";
import RenderContent from "@/components/RenderContent/RenderContent.vue";
import { getHeaderData } from "@/components/SEO/helpers";
import { useHead } from "@vueuse/head";
import { GENERAL_FEEDBACK_URL } from "@/constants/feedback";
import { useRoute } from "vue-router";
import { Tags } from "../../composables/types";

export default defineComponent({
  name: "HomePage",
  components: {
    CollectionCard,
    RenderContent,
  },
  setup() {
    const { load, result } = useContent();

    const route = useRoute();

    const home = computed(() =>
      result.value?.id === "home" ? result.value : undefined
    );

    const seo = computed(() => home.value?.seo);

    const collections = computed(
      () => home.value?.collectionsCollection?.items
    );

    const panels = computed(() => home.value?.homeContentCollection?.items);

    type Item = { tags: Tags[] | null };

    const galleries = computed(() => home.value?.galleries?.items);

    const TAGS: Tags[] = [
      "museums",
      "primers",
      "artists",
      "themes",
      "places",
      "learn",
    ];

    const countTags = (
      items: Item[],
      knownTags: Tags[]
    ): Record<Tags, number> =>
      items.reduce((acc, item) => {
        item.tags?.forEach((tag) => {
          if (knownTags.includes(tag)) {
            acc[tag] = (acc[tag] ?? 0) + 1;
          }
        });
        return acc;
      }, Object.fromEntries(knownTags.map((tag) => [tag, 0])) as Record<Tags, number>);

    const tagCounts = computed(() =>
      countTags(galleries.value as unknown as Item[], TAGS)
    );

    const headerData = computed(() =>
      getHeaderData(seo.value, { url: window.location.href })
    );

    onMounted(async () => {
      await load({ contentType: "home", slug: "" });
      if (route?.hash === "#explore") {
        document.getElementById("start-button")?.click();
      }
    });

    useHead({
      title: computed(() => headerData.value?.title || "Art Mindfully"),
      meta: computed(() => headerData.value?.meta || []),
      link: computed(() => headerData.value?.link || []),
    });

    return {
      home,
      panels,
      collections,
      galleries,
      tagCounts,
      GENERAL_FEEDBACK_URL,
    };
  },
});
